import { render, staticRenderFns } from "./SmLegend.vue?vue&type=template&id=115bde5a&scoped=true&"
import script from "./SmLegend.vue?vue&type=script&lang=ts&"
export * from "./SmLegend.vue?vue&type=script&lang=ts&"
import style0 from "./SmLegend.vue?vue&type=style&index=0&id=115bde5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115bde5a",
  null
  
)

export default component.exports